import { GetProjectFiles, GetProjectFilesResponse } from '../types'

function mapProjectFiles(response: Partial<GetProjectFilesResponse> = []): GetProjectFiles {
  return response?.map((item) => mapProjectFile(item)) || []
}

function mapProjectFile(response: Partial<GetProjectFilesResponse[0]> = {}): GetProjectFiles[0] {
  return {
    id: response?.id || 0,
    name: response?.name || '',
    url: response?.url || '',
    type_id: response?.type_id || 0,
    kind: response?.kind || '',
    user: null,
  }
}

const mappers = { mapProjectFiles, mapProjectFile }

export default mappers
